module.exports = __webpack_public_path__ + "media/images/thumbnails/thumbs_multiupload-c13fd0a7eb9f3f1193be06de423379ee.jpg";